/**
 * @generated SignedSource<<5db6c688b9fe3ff172cc191eb5f21aa7>>
 * @relayHash 82cec3c63db589e88c57d1b7c9ffdd78
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d02698f3a654a9b369e187aaa74452eb584b4a52402ac7cce830d28bbf1c14f2

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type menuNavigationAppsSidebarFiltersGlobalScopeQuery$variables = {
  cloudId: string;
  first?: number | null | undefined;
};
export type menuNavigationAppsSidebarFiltersGlobalScopeQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"starredFiltersList_navigationAppsSidebarCommon" | "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection">;
  };
};
export type menuNavigationAppsSidebarFiltersGlobalScopeQuery = {
  response: menuNavigationAppsSidebarFiltersGlobalScopeQuery$data;
  variables: menuNavigationAppsSidebarFiltersGlobalScopeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v4 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v5 = {
  "kind": "ScalarField",
  "name": "jql"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    }
  ],
  "type": "JiraCustomFilter"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "starredFiltersList_navigationAppsSidebarCommon"
            },
            {
              "args": [
                (v1/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFilterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v3/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraFilter"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "isFavourite",
                "value": false
              }
            ],
            "concreteType": "JiraSystemFilterConnection",
            "kind": "LinkedField",
            "name": "systemFilters",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSystemFilterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraSystemFilter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "type": "JiraFilter",
                        "abstractKey": "__isJiraFilter"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d02698f3a654a9b369e187aaa74452eb584b4a52402ac7cce830d28bbf1c14f2",
    "metadata": {},
    "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d98a1e778472dcda651accc837e5ad2e";

export default node;
